import { render, staticRenderFns } from "./SpeechBubbleFloat.vue?vue&type=template&id=abf0dff4"
import script from "./SpeechBubbleFloat.vue?vue&type=script&lang=ts"
export * from "./SpeechBubbleFloat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports